export default {"src":"/_next/static/media/relationship-interaction.mono.063c4cba.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};